import { render, staticRenderFns } from "./CatalogItemEditPage.vue?vue&type=template&id=00a04df5&scoped=true"
import script from "./CatalogItemEditPage.vue?vue&type=script&lang=js"
export * from "./CatalogItemEditPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogItemEditPage.vue?vue&type=style&index=0&id=00a04df5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a04df5",
  null
  
)

export default component.exports